const Footer = () => {
    return (
      <footer className="footer mt-auto py-3 bg-dark">
        <div className="container">
          <p className="text-light">Final Feitasy - Conheça o projeto no
            <a style={{color: "#97C2FC"}}href="https://github.com/WebisD/final-feitasy-analysis" target="_blank" rel="noreferrer"> repositório github</a>
          </p>
        </div>
      </footer>
    );
  }
  
  export default Footer;